import React from 'react';
import { Field } from 'react-final-form';
import { InputAdornment } from '@mui/material';
import { TextField } from 'mui-rff';
import FieldLayout from './FieldLayout';

const TextboxField = ({ id, name, optional, unit, description, warning }) => {
    const label = name;

    return (
        <FieldLayout description={description} warning={warning}>
            <Field name={id} placeholder={label} optional={optional} unit={unit}>
                {(fieldProps) => {
                    return (
                        <TextField
                            variant="standard"
                            label={fieldProps.placeholder}
                            name={fieldProps.input.name}
                            testid={id}
                            margin="none"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment key={`${id}-Adornment`} position="end">
                                        <label>{unit}</label>
                                    </InputAdornment>
                                ),
                            }}
                            style={{ marginBottom: '1rem' }}
                            autoComplete="off"
                            required={optional === false}
                        />
                    );
                }}
            </Field>
        </FieldLayout>
    );
};

export default TextboxField;
